import { EventEmitter } from 'ahooks/lib/useEventEmitter';
import { LLog, LOG_COMPONENTS, LOG_OPERATIONS } from 'src/lib/logging';

export type tLeadActiveChange = { id: string; active: boolean };

/**
 * BUG-1126: a lead archived or activated from the chat menu. The single
 * archive goes through Ragnarok, which sends no `lead-updated` socket frame,
 * so the chat list (Messenger.hook) learns about it from here. Carries the
 * lead the request was for, whatever chat is open when the answer lands.
 */
export const leadActiveChangedEvent = new EventEmitter<tLeadActiveChange>();

/**
 * Tells the chat list a lead's `active` changed. Called after the archive
 * already succeeded, so a subscriber that throws is logged, never surfaced
 * as a failed archive (`EventEmitter.emit` re-throws what a subscriber
 * raises). With no list mounted (Pipe, Directory) this is a no-op.
 */
export function emitLeadActiveChanged(change: tLeadActiveChange): void {
  try {
    leadActiveChangedEvent.emit(change);
  } catch (error) {
    LLog.error(
      {
        component: LOG_COMPONENTS.UI,
        method: 'emitLeadActiveChanged',
        operation: LOG_OPERATIONS.ERROR,
      },
      'Lead active change subscriber threw',
      error instanceof Error ? error : new Error(String(error)),
      { leadId: change.id },
    );
  }
}
